import * as React from "react";
// import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
// import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
// import {Button, Col, Container, Row} from "reactstrap";
// import {HasPermission} from "../HasPermission";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {LGAPicker} from "../form/fields/LGAPicker";
 import {ToastContainer} from 'react-toastify';
// import { useState } from 'react';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

     
// const qs = require('qs');

const IWindow: IWindow = (window as IWindow);

export class ElectionPollingUnitAddResultFormData {
    @observable user_level = IWindow.initialState.user.level;
    @observable party_competitor_party_result = 1;
    @observable election_id = null;
	    	
    @observable party_id = null;
    @observable candidate_id = null;
    @observable election_position_id = null;
    @observable number_of_votes  : string | null = null; // : number | null = null;
    @observable obj_data = Array<any>();  // [];
    @observable accredited_voters : number | null = null;
    @observable pu_registered_voters  : number | null = null;
    @observable disputed_voters  : number | null = null;
    @observable rejected_voters  : number | null = null;
    @observable user_defined_1  : number | null = null;
    @observable user_defined_2  : number | null = null;
    @observable verified_voters_from_cr  : number | null = null;
    @observable level = '';
    @observable state_id = '';
    @observable obj_data_value : string | null = null;
    @observable senatorial_district_id = '';
    @observable federal_constituency_id = '';
    @observable state_constituency_id = '';
    @observable local_government_area = null;
    @observable local_government_area_id = '';
    @observable ward_id = '';
    @observable election_polling_unit_id = null;
	
    
}

export class ElectionPollingUnitAddResultForm extends CrudForm {
    @observable registeredVoter  : any;
    modelName = 'ElectionPollingUnitAddResult';
	
	    
    party_id = IWindow.initialState.user.party_id;
    @observable nofvotes = false;
    @observable avoters = false;
    @observable rvoters = false;
    @observable dvoters = false;
    @observable regvoters = false;
	@observable party_candidates: [];
	 
	@observable obj = Array<any>();  // [];
	 @observable number_of_votes_array  = []; // : number | null = null;
	@observable electionSubscription = {
        registeredVoters : 0,
        accreditedVoters : 0,
        rejectedVoters   : 0,
        disputedVoters   : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        incidence_count: 0,
        election_candidates_votes: [],
        pollingUnitName: [],
        pollingUnitCode: [],
        pollingUnitState: [],
        total_votes: [],
        grandTotal: [],
        election_positions: [],
        check_list_count: [],
       
    };	


    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
		
   }
 
   
   onInputchange(i: any,e: any) {
   
   // console.log("i->" + i);
  //  console.log("e->" + e.target.value);
	  
	this.obj[i] = e.target.value;
	
	this.formStore.setValue('obj_data', this.obj);	
	this.formStore.setValue('obj_data_value', btoa(JSON.stringify(Object.assign({}, this.obj))) );	
	this.formStore.setValue('number_of_votes', btoa(JSON.stringify(Object.assign({}, this.obj))) );	
	
	// console.log("vl->" + btoa(JSON.stringify(Object.assign({}, this.obj)))  );
	 
  };
   
   onChangeElection = () => { 
   console.log('call change event' + this.formStore.getValue('election_polling_unit_id'));
        this.formStore.getValue('election_id') && (IWindow.initialState.user.polling_unit_id || this.formStore.getValue('election_polling_unit_id'))  &&
          api.electionPollingUnitAddResult.getElectionPartyListAction({
            election_id: this.formStore.getValue('election_id'),
			polling_unit_id:  (IWindow.initialState.user.polling_unit_id || this.formStore.getValue('election_polling_unit_id')),
        }).then((data: any) => {
             this.electionSubscription = data;
			 
			 console.log('election subscription - ' + this.electionSubscription);
			 
			 this.party_candidates = data.election_candidates_votes;
			 
			 console.log('party candidate - ' + this.party_candidates);
			 
             /*this.party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.formStore.getValue('party_id') );
             }); */
			

             

             
        });
    };
	
	
   
   getCandidateRow = (candidate: any,totalvotes: any,index: any) => {
		
        return <tr key={'candidate-row' + candidate.id}>
			
			<td>
                <div className=""> 
				{ 
					candidate.party_logo && candidate.party_logo.url ?
				<img src={candidate.party_logo.url} style={{width: 50, height: 50}}/> :
                                    <img src="https://fakeimg.pl/50x50/"/>                
									}
									</div>
                
            </td>
			
            <td>
                <div className="">
                    {candidate.party_name}
                </div>
            </td>
			<td>
				<div className="">{candidate.name}
                </div>
			</td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            <td><span className="" >
			
			</span></td>
			<td className="text-center "  >
			{
				 <input
					name='number_of_votes1[]'
					placeholder='Enter Vote'
				    type="number"
					onChange={e => this.onInputchange(candidate.id + "_" + candidate.party_id , e)} 
					
				/>
		  
			//   <Field
			//		key="{candidate.id}"
            //        type="number"
            //        label=""
			//		name="number_of_votes"
			//		placeholder="Enter Vote"
			//		component={Input}
            //        required={true}
			//		store={this.formStore}
            //       min="0"
            //      //  onChange={e => this.onInputchange(index, e)} 
            //    />
			}
			
			</td>
			<td className="text-center">
                <div className="comp-votes">
                    <span></span>
                </div>
            </td>
			
			
        </tr>
		
		
		
    };
	
	
	onSubmit = (props: any) => {
		console.log("res " , props);
		console.log("res received ");
	};	

     onKeyPress = (value: any) => {

        const validate = /^[0-9\b]+$/;
        if (!validate.test(value) && value) {
          //  this.formStore.setValue('number_of_votes', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('accredited_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('pu_registered_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('disputed_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('rejected_voters', Number(value.substring(0, value.length - 1)));
            
        }

        if (this.formStore.getValue('rejected_voters') > this.registeredVoter) {
            // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
            if(!this.regvoters)
             toast.error('You are adding more than number of voters, kindly note that');
 
            this.regvoters = true;
                 
            
         }

       /* if (this.formStore.getValue('number_of_votes') > this.registeredVoter) {
           // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
           if(!this.nofvotes)
            toast.error('You are adding more than number of voters, kindly note that');

           this.nofvotes = true;
                
           
        } */

        if (this.formStore.getValue('accredited_voters') > this.registeredVoter) {
           // this.formStore.setValue('accredited_voters', Number(this.registeredVoter));
           if(!this.avoters)
            toast.error('You are adding more than number of voters, kindly note that');

           this.avoters = true;
        }

        if (this.formStore.getValue('pu_registered_voters') > this.registeredVoter) {
          //  this.formStore.setValue('pu_registered_voters', Number(this.registeredVoter));
          if(!this.rvoters)
            toast.error('You are adding more than number of voters, kindly note that');

          this.rvoters = true;
        }

        if (this.formStore.getValue('disputed_voters') > this.registeredVoter) {
         //   this.formStore.setValue('disputed_voters', Number(this.registeredVoter));
         if(!this.dvoters)
            toast.error('You are adding more than number of voters, kindly note that');

         this.dvoters = true;
        }
    };
 

    loadMoreData(props: any, module: any) {
        if (Number(window.localStorage.getItem('election_id')) > 0) {
            this.formStore.setValue('election_id', Number(window.localStorage.getItem('election_id')));
            this.getPollingUnitByUserPollingUnitId();
        } else {
            this.formStore.setValue('election_id', null);
        }
    }

    getPollingUnitByUserPollingUnitId = () => {
        if(!IWindow.initialState.user.polling_unit_id || !this.formStore.getValue('election_id')){
           return;
        }
        api.electionPollingUnit.getListAction({
            page:0,
            filters: {
                polling_unit_id: IWindow.initialState.user.polling_unit_id,
                election_id: this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
            if(data && data.length){
               this.formStore.setValue('election_polling_unit_id', data[0].id);
             }
        });

    };

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency', 'polling_unit'])
            .includes(this.formStore.getValue('level'))) ?

            <Field
                key={"form_state_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="State"
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.formStore.getValue('election_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={() => {
                    this.formStore.setValue('senatorial_district_id', null);
                    this.formStore.setValue('federal_constituency_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('state_constituency_id', null);
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
					this.onChangeElection();
                }}
            /> : '';
    };

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?

            <Field
                key={"form_senatorial_district_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="Senatorial District"
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
					this.onChangeElection();
                }}
            /> : '';
    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                label="Federal Constituency"
                key={"form_federal_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
					this.onChangeElection();
                }}
            /> : '';
    }

    lgaDropDown() {
        return (!((['ward', 'state_constituency'])
            .includes(this.formStore.getValue('level')))  &&
        (this.formStore.getValue('state_id') ||
            this.formStore.getValue('senatorial_district_id') ||
            this.formStore.getValue('federal_constituency_id')
        ) ) ?
            <Field
                key={"form_local_government_area_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id') +
                this.formStore.getValue('state_id') +
                this.formStore.getValue('senatorial_district_id') +
                this.formStore.getValue('federal_constituency_id')
                }
                label={"LGA"}
                placeholder={"LGA"}
                name="local_government_area"
                store={this.formStore}
                multi={false}
                component={LGAPicker}
                returnObject={false}
                filters={{
                    election_id: this.formStore.getValue('election_id'),
                    state_id: this.formStore.getValue('state_id'),
                    senatorial_district_id: this.formStore.getValue('senatorial_district_id'),
                    federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                    candidateIds: [this.formStore.getValue('candidate_id')],
                    party_id: this.formStore.getValue('party_id'),
                    user_level: this.formStore.getValue('user_level'),
                }}
                onChange={(value: any) => {
                    if(value){
                        this.formStore.setValue('local_government_area_id', value.id);
                    }
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
					this.onChangeElection();
                }}

            /> : '';
    };

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?

            <Field
                label="State Constituency"
                key={"form_state_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
					this.onChangeElection();
                }}
            /> : '';
    }

    wardsDropDown() {
        return  (this.formStore.getValue('local_government_area_id') ||
            this.formStore.getValue('state_constituency_id') ||
            this.formStore.getValue('level') === 'polling_unit') ?

        <Field
            key={"form_ward_id_" +
            this.formStore.getValue('election_id') +
            this.formStore.getValue('party_id') +
            this.formStore.getValue('election_position_id') +
            this.formStore.getValue('level') +
            this.formStore.getValue('candidate_id') +
            this.formStore.getValue('state_id') +
            this.formStore.getValue('senatorial_district_id') +
            this.formStore.getValue('federal_constituency_id') +
            this.formStore.getValue('state_constituency_id') +
            this.formStore.getValue('local_government_area_id')
            }
            label="Ward"
            name="ward_id"
            placeholder="Select Ward"
            component={Select}
            loadOptions = { () => {
                return api.ward.getListAction({
                    filters : {
                        state_id: this.formStore.getValue('state_id'),
                        local_government_area_id: this.formStore.getValue('local_government_area_id'),
                        state_constituency_id: this.formStore.getValue('state_constituency_id'),
                        election_position_id: this.formStore.getValue('election_position_id'),
                        level: this.formStore.getValue('level'),
                        candidateIds: [this.formStore.getValue('candidate_id')],
                        party_id: this.formStore.getValue('party_id'),
                        user_level: this.formStore.getValue('user_level'),
                        no_position: (this.formStore.getValue('level') === 'polling_unit') ? 1 : null,
                    }
                });
            }}
            store={this.formStore}
            onChange={() => {
                this.formStore.setValue('election_polling_unit_id', null);
				this.onChangeElection();
            }}
        /> : ''
    }

    renderFields() {
        return (
            <>
				 <ToastContainer autoClose={5000} />
                <Field
                    key={"form-field-election-id"}
                    placeholder="Select Election"
                    name="election_id"
                    component={Select}
                    required={true}
                    loadOptions={api.election.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.getPollingUnitByUserPollingUnitId();
                        this.formStore.setValue('party_id', null);
                        this.formStore.setValue('candidate_id', null);
						this.onChangeElection();
                    }}
                />
				
				
				
				 

                 {
				// 	this.formStore.getValue('election_id') ?

                //    <Field
                //        key={'form_party_id_' + this.formStore.getValue('election_id')}
                //        name="party_id"
                //        placeholder="Select Party"
                //        component={Select}
                //        disabled={!this.formStore.getValue('election_id')}
                //        required={true}
                //        loadOptions={() => {
                //            return api.party.getListAction({
                //                filters: {
                //                    election_id: this.formStore.getValue('election_id'),
                //                    include_competitor_party: 1
                //                }
                //            }).then((data: any) => {
                //                return data.data;
                //            });
                //        }}
                //       store={this.formStore}
                //        onChange={() => {
                //            this.formStore.setValue('candidate_id', null);
                //            //this.formStore.setValue('election_position_id', null);
                //        }}
                //    /> : ''  
                }

                {this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_election_position_id_' + this.formStore.getValue('election_id') + this.formStore.getValue('party_id')}
                        name="election_position_id"
                        placeholder="Select Position"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
                        loadOptions={() => {
                            return api.electionPosition.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    other_party_id: (this.party_id != this.formStore.getValue('party_id') ?
                                        this.formStore.getValue('party_id') : null),
                                    party_id: this.party_id
                                }
                            });
                        }}
                        returnObject={true}
                        extraKey={'level'} 
                        store={this.formStore}
                        onChange={(item: any) => {
                            this.formStore.setValue('level', null);
                            if (item) {
                                this.formStore.setValue('level', item.extraKey);
                            }
                            this.formStore.setValue('candidate_id', null);
                            this.formStore.setValue('state_id', null);
                            this.formStore.setValue('senatorial_district_id', null);
                            this.formStore.setValue('federal_constituency_id', null);
                            this.formStore.setValue('local_government_area_id', null);
                            this.formStore.setValue('state_constituency_id', null);
                            this.formStore.setValue('ward_id', null);
							this.onChangeElection();
                        }}
                    />
                    : ''
                }

                {this.formStore.getValue('party_id') && this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_candidate_filter_election_result_' +
                        this.formStore.getValue('party_id') + '_election_id' +
                        this.formStore.getValue('election_id') + '_election_position_id' +
                        this.formStore.getValue('election_position_id')}
                        name="candidate_id"
                        placeholder="Select Candidate"
                        component={Select}
                        disabled={!this.formStore.getValue('party_id')}
                        required={true}
                        loadOptions={() => {
                            return api.candidate.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    party_id: this.formStore.getValue('party_id'),
                                    election_position_id: this.formStore.getValue('election_position_id'),
                                }
                            });
                        }}
                        store={this.formStore}
                        returnObject={true}
                        onChange={() => {
                        }}
                    /> : ''
                }

                {
                    this.formStore.getValue('level') && !IWindow.initialState.user.polling_unit_id ?
                        <>
                            {this.stateDropDown()}
                            {this.senatorialDistrictDropDown()}
                            {this.federalConstituencyDropDown()}
                            {this.formStore.getValue('level') !== 'state_constituency' ? this.lgaDropDown() : ''}
                            {this.stateConstituencyDropDown()}
                            {this.wardsDropDown()}

                        </> : ''
                }
                {
                    !IWindow.initialState.user.polling_unit_id &&
                    this.formStore.getValue('election_id') /* &&
                    this.formStore.getValue('candidate_id') */  ?
                        <Field
                            key={"form_election_polling_unit_id_" + this.formStore.getValue('election_id') +
                            this.formStore.getValue('ward_id') + this.formStore.getValue('election_position_id') 
                            + this.formStore.getValue('election_polling_unit_id') + this.formStore.getValue('local_government_area_id')
                            }
                            label={"Polling Unit"}
                            placeholder={"Polling Unit"}
                            name="election_polling_unit_id"
                            store={this.formStore}
                            component={Select}

                            loadOptions={() => {
                               return api.electionPollingUnit.getListAction({
                                    filters: {
                                        election_id: this.formStore.getValue('election_id'),
                                        ward_id: this.formStore.getValue('ward_id'),
                                        local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                        election_polling_unit_id: this.formStore.getValue('election_position_id'),
                                        no_position_candidate_id: /*this.formStore.getValue('level') == 'polling_unit' ?
                                              this.formStore.getValue('candidate_id') : null*/ null
                                    }
                                })
                            }}
 
                            onChange={(item: any) => {
								this.onChangeElection();
                                return api.electionPollingUnit.getVoteListAction({
                                  filters: {
                                     election_polling_unit_id : this.formStore.getValue('election_polling_unit_id'),
                                     local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                     ward_id : this.formStore.getValue('ward_id'),
                                     election_id: this.formStore.getValue('election_id'),
                                   }
                                }).then((data: any) => {
                                    if(data && data.length){
                                       this.registeredVoter = data[0].registered_voters;
                                       // this.formStore.setValue('number_of_votes',data[0].registered_voters);
                                       this.formStore.setValue('accredited_voters', data[0].registered_voters);
                                       this.formStore.setValue('pu_registered_voters', data[0].registered_voters);
                                       this.formStore.setValue('disputed_voters', data[0].registered_voters);
                                       // this.formStore.setValue('rejected_voters', data[0].registered_voters);
                                       
                                    }
                                });
								
                            }}

                        /> : ''
                }
 
                    
                
 
                
 
                <Field
                    label="Polling Unit Accredited Voters"
                    name="accredited_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Registered Voters at Polling Unit"
                    name="pu_registered_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Polling Unit Disputed Votes"
                    name="disputed_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Polling Unit Rejected Votes"
                    name="rejected_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />
				
				 <Field
				    label="Voting Value"
                    name="number_of_votes"
                    component={Input}
                    type="hidden"
                    store={this.formStore}
					onChange={this.onKeyPress}
                 /> 
				 
				 
				   
				
				<table className="table table-hover border-top bgcolornw">
												<thead>
													<th>Logo</th>
													<th>Party</th>
													<th>Candidate Name</th>
													<th className="text-center">Postions</th>
													<th></th>
													<th className="text-center">Votes</th>
													<th className="text-center"></th>
												</thead>
                                                <tbody>
												{
													
												
                                                    this.formStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any,index) => {
                                                            return (
                                                                this.getCandidateRow(candidate,this.electionSubscription.total_votes,index)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td colSpan={7}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }
												
												
                                                        
                                                
												
																												

                                                </tbody>
                                            </table>

                {/*<Field
                    label="Verified voters from CR."
                    name="verified_voters_from_cr"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #2"
                    name="user_defined_1"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #1"
                    name="user_defined_2"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />*/}
            </>
        );
    }
}




export class ElectionPollingUnitAddResultPage extends React.Component {
    modelName = 'ElectionPollingUnitAddResult';

    /* constructor(props: any) {
        super(props);
    } */
	 render() {
        return (
            <>
                <ElectionPollingUnitAddResultForm
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPollingUnitAddResultPage.tsx